import { MsalProvider } from "@azure/msal-react";
import {
  PublicClientApplication,
  EventType,
  EventMessage,
} from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";
import { isWrongTenantError, markForceAccountPicker } from "./loginHelpers";
import { useEffect, useState } from "react";

const msalInstance = new PublicClientApplication(msalConfig);

let initPromise: Promise<void> | null = null;

function initializeMsalInstance() {
  if (!initPromise) {
    initPromise = msalInstance.initialize().then(() => {
      msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_FAILURE) {
          console.error("MSAL: Login failure", event.error);
          if (event.error && isWrongTenantError(event.error)) {
            markForceAccountPicker();
          }
        }
      });
    });
  }
  return initPromise;
}

export default function AuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    initializeMsalInstance()
      .then(() => {
        // Do NOT call handleRedirectPromise here.
        // CustomLoginCallback is the single designated handler for the redirect response.
        setIsInitialized(true);
      })
      .catch((error) => {
        console.error("MSAL: initialization failed", error);
        setIsInitialized(true);
      });
  }, []);

  if (!isInitialized) {
    return null;
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
